import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { userStateRouting } from 'src/environments/environment';
import { IAPIUserInformationDef } from './api_interfaces/core';
import { PrivilegesHandler } from './classes/PrivilegesHandler';
import { ApiService } from './services/api/core/api.service';
import { LanguageService } from './services/language/language.service';
import { RSCUser } from './controllers/RSCUser';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
})
export class AppComponent {
  subscriptions: Subscription[] = [];
  initialized = false;
  constructor(
    private platform: Platform,
    private language: LanguageService,
    private router: Router,
    private api: ApiService,
  ) {
    // this.router.events.subscribe((event) => {
    //   console.log(
    //     `%c[ROUTER EVENT] ${event.constructor.name}`,
    //     'color: teal',
    //     (event as any).url ?? event,
    //   );
    // });
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.language.setInitialAppLanguage();
      this.api.initialized.subscribe({
        next: (value: boolean) => {
          if (value) {
            RSCUser.GetCurrentUserSync().ChechLogin();
            if (userStateRouting) {
              RSCUser.GetCurrentUserSync().Subscribe({
                next: (user: RSCUser) => {
                  // Initialize routes checkquer
                  if (user.IsLoggedIn()) {
                    console.log(
                      'Iniciado sesión',
                      user.IsLoggedIn(),
                      user.IsAdmin(),
                    );
                    if (
                      window.location.pathname.indexOf('/admin') < 0 &&
                      window.location.pathname.indexOf('password-reset') < 0 &&
                      window.location.pathname.indexOf('terms') < 0 &&
                      window.location.pathname.indexOf('privacy') < 0 &&
                      window.location.pathname.indexOf('loading-oauth') < 0 &&
                      window.location.pathname.indexOf('oauth') < 0
                    ) {
                      const returnUrl = new URLSearchParams(
                        window.location.search,
                      ).get('return_to_url');
                      this.router
                        .navigate([returnUrl || '/admin'], {
                          replaceUrl: true,
                        })
                        .then(() =>
                          setTimeout(() => window.location.reload(), 0),
                        );
                    }
                    if (user.IsAdmin()) {
                    } else {
                      // Toast and logout
                      // this.toast.success('Te invitamos a utilizar la aplicación móvil que podrás descargar en el AppStore y PlayStore', 5000);
                      // user.Logout();
                    }
                  } else {
                    const returnUrl = new URLSearchParams(
                      window.location.search,
                    ).get('return_to_url');
                    // RSCCountry.ResetCurrentCountry();
                    if (window.location.pathname.indexOf('admin') >= 0) {
                      this.router
                        .navigate(['/home'], {
                          queryParams: returnUrl
                            ? { return_to_url: returnUrl }
                            : {},
                          replaceUrl: true,
                        })
                        .then(() =>
                          setTimeout(() => window.location.reload(), 0),
                        );
                    }
                  }
                },
              });
            }
            this.initialized = true;
          }
        },
      });
      // this.system.checkForUpdates();
      // // Initialize routes checkquer
      // if (userStateRouting) {
      //   ((suscription: any) => {
      //     suscription = this.api.system.initialized().subscribe({
      //       next: (value) => {
      //         if (value) {
      //           setTimeout(() => suscription.unsubscribe(), 10);
      //           this.subscriptions.push(this.api.user.getInformation().subscribe({
      //             next: (userInfo: IAPIUserInformationDef) => {
      //               if (userInfo?.user?.id > 0) {
      //                 this.api.client.ideas.reactions.loadDefs();
      //               }
      //               if (userInfo?.admin_account?.id > 0) {
      //                 if (window.location.pathname.indexOf('/admin') < 0
      //                   && window.location.pathname.indexOf('recover') < 0
      //                   && window.location.pathname.indexOf('terms') < 0
      //                   && window.location.pathname.indexOf('privacy') < 0
      //                   && window.location.pathname.indexOf('cookies') < 0) {
      //                   this.router.navigate(['/admin'], { replaceUrl: true });
      //                 }
      //                 // Setting admin role def
      //                 PrivilegesHandler.instance.setRoleDef(userInfo?.admin_account?.role || {} as any);
      //               } else if (userInfo?.leadership_account?.profile.id > 0) {
      //                 if (window.location.pathname.indexOf('/leadership') < 0
      //                   && window.location.pathname.indexOf('recover') < 0
      //                   && window.location.pathname.indexOf('terms') < 0
      //                   && window.location.pathname.indexOf('privacy') < 0
      //                   && window.location.pathname.indexOf('cookies') < 0) {
      //                   this.router.navigate(['/leadership'], { replaceUrl: true });
      //                 }
      //               } else if (userInfo?.director_account?.profile.id > 0) {
      //                 if (window.location.pathname.indexOf('/director') < 0
      //                   && window.location.pathname.indexOf('recover') < 0
      //                   && window.location.pathname.indexOf('terms') < 0
      //                   && window.location.pathname.indexOf('privacy') < 0
      //                   && window.location.pathname.indexOf('cookies') < 0) {
      //                   this.router.navigate(['/director'], { replaceUrl: true });
      //                 }
      //               } else if (userInfo?.client_account?.profile.id > 0) {
      //                 if (window.location.pathname.indexOf('/w') < 0
      //                   && window.location.pathname.indexOf('recover') < 0
      //                   && window.location.pathname.indexOf('terms') < 0
      //                   && window.location.pathname.indexOf('privacy') < 0
      //                   && window.location.pathname.indexOf('cookies') < 0) {
      //                   this.router.navigate(['/w'], { replaceUrl: true });
      //                 }
      //               } else {
      //                 if (
      //                   window.location.pathname.indexOf('home') < 0
      //                   && window.location.pathname.indexOf('recover') < 0
      //                   && window.location.pathname.indexOf('terms') < 0
      //                   && window.location.pathname.indexOf('privacy') < 0
      //                   && window.location.pathname.indexOf('cookies') < 0
      //                 ) {
      //                   this.router.navigate(['/home'], { replaceUrl: true });
      //                 }
      //               }
      //             }
      //           }));
      //           this.api.user.checkLogin();
      //         }
      //       }
      //     });
      //   })(null);
      // } else {
      //   this.api.user.checkLogin();
      // }
    });
  }
}
